import NextStepButton from './NextStepButton'
import Accordion from './Accordion/Accordion'
import AccordionItem from './Accordion/AccordionItem'

// TODO: mover a @colescba/ui
import WordCount from './WordCount'

const components = {
  NextStepButton,
  Accordion,
  AccordionItem,
  WordCount,
}

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Object.keys(components).forEach(component => Vue.component(component, components[component]))
  },
}
